import axios from 'axios'

const instance = axios.create({
  baseURL: '/cloudmoney',
  timeout: 5000
})

instance.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem('token')
    if (token) {
      config.headers = {
        'token': token
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
instance.interceptors.response.use(
  res => {
    // //TODO token无效等需重新登录的code
    // if (sessionStorage.getItem('token') == null
    //   || sessionStorage.getItem('token') == ''
    //   || res.code == XXXXXXX) {
    //   //TODO 跳转登录页面
    //   return Promise.reject(new Error('token invalid'))
    // } else {
    //   return res.data
    // }
    return res.data
  },
  error => {
    return Promise.reject(error)
  }
)

export default instance
